const setupTab = (conversionBtn) => {
  conversionBtn.addEventListener('click', function() {
    if(!conversionBtn.classList.contains('active')){

      const activeElems = document.querySelectorAll('[data-size-guide-unit].active');
      activeElems.forEach((activeElem) => activeElem.classList.remove('active'));

      const newActiveElems = document.querySelectorAll(`[data-size-guide-unit="${conversionBtn.dataset.sizeGuideUnit}"]`);
      newActiveElems.forEach((newActiveElem) => newActiveElem.classList.add('active'));

      const tables = document.querySelectorAll('.size-guide-body__table table');

      tables.forEach((table) => {
        Array.from(table.rows).forEach((row) => {
          Array.from(row.cells).forEach((cell) => {

            if (cell.textContent.includes('cm') && !cell.dataset.originalCM) {
              cell.dataset.originalCM = cell.textContent;
            }

            if(cell.textContent.includes('cm') && conversionBtn.dataset.sizeGuideUnit === 'IN'){
              const numericValue = cell.textContent.split('cm')[0];
              cell.textContent = Math.floor((parseFloat(numericValue)*0.39370)*10)/10 + 'in';
            }

            if(cell.textContent.includes('in') && conversionBtn.dataset.sizeGuideUnit === 'CM'){
              if (!cell.dataset.originalCM) {
                const numericValue = cell.textContent.split('in')[0];
                cell.textContent = Math.floor((parseFloat(numericValue)/0.39370)*10)/10 + 'cm';
              } else {
                cell.textContent = cell.dataset.originalCM;
              }
            }
          })
        })
      })
      
    }
  })
}

const sizeChartConversion = () => {
  const conversionBtns = document.querySelectorAll('[data-size-guide-unit]');
  if (!conversionBtns) return false;
  conversionBtns.forEach(conversionBtn => setupTab(conversionBtn));
}

export {
  sizeChartConversion,
};
